import { render, staticRenderFns } from "./bcc.vue?vue&type=template&id=31d8e79a&scoped=true&"
import script from "./bcc.vue?vue&type=script&lang=js&"
export * from "./bcc.vue?vue&type=script&lang=js&"
import style0 from "./bcc.vue?vue&type=style&index=0&id=31d8e79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8e79a",
  null
  
)

export default component.exports